export default __webpack_public_path__ + "static/media/pocket.e1268d03.svg";